import {ApplicationController} from '~/app/javascript/controllers/application';

export default class extends ApplicationController {
  static targets = ["yes", "no", "agentTable", "overlay"]

  userRole: string
  requireAgent: boolean
  requireAgentBase: boolean

  connect() {
    this.userRole = this.data.get('user-role')
    this.requireAgent = this.data.get('require-agent') === 'true'
    this.requireAgentBase = this.data.get('require-agent-base') === 'true'

    // Listen for changes to the report_type field
    const reportTypeField = document.getElementById('order_report_type')
    if (reportTypeField) {
      reportTypeField.addEventListener('change', () => {
        this.updateRequireAgent()
      })
    }

    // Listen for clicks on pricing cards, scoped to the pricing cards container
    const pricingCardsContainer = document.querySelector('.pricing-cards-container')
    if (pricingCardsContainer) {
      pricingCardsContainer.addEventListener('click', (event) => {
        const target = event.target as HTMLElement
        if (target.closest('.pricing-card')) {
          // Use MutationObserver for more reliable synchronization
          this.observeReportTypeChange()
        }
      })
    }

    if (this.userRole === 'agent') {
      this.overlayTarget.setAttribute('style', 'display:block')
    }

    if (this.requireAgent) {
      this.yes(new Event('default'))
      this.enableForm()
    } else {
      this.no(new Event('default'))
      this.disableForm()
    }
  }

  updateForm(event) {
    event.preventDefault()
    // TODO: use stimulus targets
    const jsElements = Array.from(this.element.getElementsByClassName('js-show-when-adding-agent'))
    const addAgentOption = document.getElementById('order_agent_attributes_id_0').parentElement

    // Find the checked radio input
    const checkedRadio = this.element.querySelector('input[name="order[agent_attributes][id]"]:checked')

    if (checkedRadio && checkedRadio.value == '0') {
      // entering new agent
      this.setRequiredAttributes(true)
      jsElements.forEach((el) =>
        el.classList.remove('hidden')
      )
      addAgentOption.classList.add('hidden')
    } else {
      // using saved agent
      this.setRequiredAttributes(false)
      addAgentOption.classList.remove('hidden')
      jsElements.forEach((el) =>
        el.classList.add('hidden')
      )
    }
  }

  yes(event) {
    event.preventDefault()

    const {noTarget, yesTarget, agentTableTarget} = this

    this.enableForm()

    noTarget.classList.remove('selected')
    yesTarget.classList.add('selected')
    agentTableTarget.classList.remove('hidden')

    this.updateForm(event)
  }

  no(event) {
    event.preventDefault()

    const {noTarget, yesTarget, agentTableTarget} = this

    this.disableForm()

    yesTarget.classList.remove('selected')
    noTarget.classList.add('selected')
    agentTableTarget.classList.add('hidden')

    this.setRequiredAttributes(false)
  }

  disableForm() {
    const inputs = this.getInputs()

    inputs.forEach((input) =>
      input.setAttribute('disabled', 'disabled')
    )
  }

  enableForm() {
    const inputs = this.getInputs()

    inputs.forEach((input) =>
      input.removeAttribute('disabled')
    )
  }

  getInputs() {
    return [...this.element.getElementsByTagName('input')]
  }

  setRequiredAttributes(isRequired: boolean) {
    const nameInput = document.getElementById('order_agent_attributes_name')

    if (isRequired && this.requireAgent) {
      nameInput.setAttribute('required', 'required')
    } else {
      nameInput.removeAttribute('required')
    }
  }

  updateRequireAgent() {
    const reportTypeField = document.getElementById('order_report_type') as HTMLInputElement
    if (reportTypeField) {
      const isRenterReport = reportTypeField.value === 'Renter'
      const previousRequireAgent = this.requireAgent
      this.requireAgent = this.requireAgentBase && !isRenterReport

      // Only update the form state if requireAgent has changed
      if (this.requireAgent !== previousRequireAgent) {
        if (this.requireAgent) {
          this.yes(new Event('auto-update'))
          this.enableForm()
        } else {
          this.no(new Event('auto-update'))
          this.disableForm()
        }
      }
    }
  }

  observeReportTypeChange() {
    const reportTypeField = document.getElementById('order_report_type') as HTMLInputElement
    if (reportTypeField) {
      const observer = new MutationObserver(() => {
        this.updateRequireAgent()
        observer.disconnect()
      })
      
      observer.observe(reportTypeField, {
        attributes: true,
        attributeFilter: ['value']
      })
      
      // Fallback timeout in case MutationObserver doesn't catch the change
      setTimeout(() => {
        this.updateRequireAgent()
        observer.disconnect()
      }, 50)
    }
  }
}
